module.exports = __webpack_public_path__ + "img/CTWP__Quiver.d25c16b4.png";